import DurationReportTable from "../components/Reports/ReportTables/workforce/DurationReportTable";
import ProductivityReportTable from "../components/Reports/ReportTables/workforce/ProductivityReportTable";
import { useLazyGetServiceRequestReportQuery } from "../Redux/service/NewReports/ServicesRequestReports";
import ServiceRequestReportTable from "../components/Reports/ReportTables/workforce/ServiceRequestReportTable";
import {
	useLazyGetAttendanceReportQuery,
	useLazyGetDailyAttendanceReportQuery,
	useLazyGetDurationReportQuery,
	useLazyGetProductivityReportQuery,
} from "../Redux/service/NewReports/Workforce";
import AttendanceReportTable from "../components/Reports/ReportTables/workforce/AttendanceReportTable";
import DailyAttendanceReportTable from "../components/Reports/ReportTables/workforce/DailyAttendanceReportTable";
import DeviceAssignmentReportTable from "../components/Reports/ReportTables/workforce/DeviceAssignmentReportTable";
import { useLazyGetDeviceAssignmentReportQuery } from "../Redux/service/Permissions/CustomerPermissions";
import ShelfAvailabilityReportTable from "../components/Reports/ReportTables/inventory/ShelfAvailabilityReportTable";
import { useLazyGetShelfAvailabilityReportQuery } from "../Redux/service/NewReports/ShelfAvailability";
import InventoryReportWidgets from "../components/Reports/ReportPage/ReportComponents/InventoryReportWidgets";
import ProductExpirationReportTable from "../components/Reports/ReportTables/inventory/ProductExpirationReportTable";
import { useLazyGetProductExpirationReportQuery } from "../Redux/service/NewReports/ProductExpiration";
import ProductExpirationWidgets from "../components/Reports/ReportPage/ReportComponents/ProductExpirationWidgets";
import { useLazyGetShelfMovementDailySummaryQuery } from "../Redux/service/NewReports/ShelfMovement";
import ShelfMovementReportTable from "../components/Reports/ReportTables/inventory/ShelfMovementReportTable";

export const REPORTS = {
	productivity: {
		component: ProductivityReportTable,
		apiHook: useLazyGetProductivityReportQuery,
		getSummary: (data) => [
			{
				title: "Total Staff",
				number: data?.summary?.totalStaff,
			},
			{
				title: "Total Tasks",
				number: data?.summary?.totalTasks,
			},
			{
				title: "Complete Tasks",
				number: data?.summary?.completedTasks,
			},
			{
				title: "Average Efficiency",
				number: data?.summary?.avgEfficiency,
			},
			{
				title: "Overload Staff",
				number: data?.summary?.overloadedStaff,
			},
			{
				title: "Underutilized Staff",
				number: data?.summary?.underperformingStaff,
			},
		],
	},
	efficiency: {
		component: DurationReportTable,
		apiHook: useLazyGetDurationReportQuery,
		getSummary: (data) => [
			{
				title: "Total Tasks",
				number: data?.summary?.totalTasks,
			},
			{
				title: "Average Planned Duration",
				number: data?.summary?.formattedAvgPlanned,
			},
			{
				title: "Average Actual Duration",
				number: data?.summary?.formattedAvgActual,
			},
			{
				title: "Over Due Percentage",
				number: data?.summary?.formattedOverduePercentage,
			},
		],
	},
	requests: {
		component: ServiceRequestReportTable,
		apiHook: useLazyGetServiceRequestReportQuery,
		getSummary: (data) => [
			{
				title: "Total Service Requests",
				number: data?.summary?.totalServiceRequests,
			},
			{
				title: "Total Completed Tasks",
				number: data?.summary?.totalCompletedTasks,
			},
			{
				title: "Average Task Duration",
				number: data?.summary?.averageTaskDuration,
			},
			{
				title: "Total Service Time",
				number: data?.summary?.totalServiceTime,
			},
		],
	},
	attendance: {
		component: AttendanceReportTable,
		apiHook: useLazyGetAttendanceReportQuery,
		getSummary: (data) => [
			{
				title: "Total Field Staff",
				number: data?.overallSummary?.totalTechnicians,
			},
			{
				title: "Total Scheduled Shifts",
				number: `${data?.overallSummary?.totalScheduledShifts} Shifts`,
			},
			{
				title: "Total On time Shifts",
				number: `${data?.overallSummary?.totalOnTimeShifts} Shifts`,
			},
			{
				title: "Total Late Shifts",
				number: `${data?.overallSummary?.totalLateShifts} Shifts`,
			},
			{
				title: "Compliance Rate",
				number: `${data?.overallSummary?.overallComplianceRate} %`,
			},
			{
				title: "Attendance Rate",
				number: `${data?.overallSummary?.overallAttendanceRate} %`,
			},
		],
	},
	dailyAttendance: {
		component: DailyAttendanceReportTable,
		apiHook: useLazyGetDailyAttendanceReportQuery,
		getSummary: (data) => [
			// {
			//   title: "Total Field Staff",
			//   number: data?.overallSummary?.totalTechnicians,
			// },
			// {
			//   title: "Total Days",
			//   number: `${data?.overallSummary?.totalDays} Days`,
			// },
			// {
			//   title: "Total Present",
			//   number: `${data?.overallSummary?.totalPresentDays} Days`,
			// },
			// {
			//   title: "Total Late",
			//   number: `${data?.overallSummary?.totalLateDays} Days`,
			// },
			// {
			//   title: "Total Early Leave",
			//   number: `${data?.overallSummary?.totalEarlyLeaveDays} Days`,
			// },
			// {
			//   title: "Avg Attendance Rate",
			//   number: `${data?.overallSummary?.avgAttendanceRate} %`,
			// },
		],
	},
	deviceAssignment: {
		component: DeviceAssignmentReportTable,
		apiHook: useLazyGetDeviceAssignmentReportQuery,
		getSummary: (data) => [
			{
				title: "Total Devices Tracked",
				number: data?.total_devices,
			},
			{
				title: "Total Active Users",
				number: data?.devices_currently_assigned,
			},
			{
				title: "Total Unique Users",
				number: data?.total_unique_users,
			},
			{
				title: "Average assignments per device",
				number: data?.average_assignments_per_device,
			},
		],
	},
	shelfAvailability: {
		component: ShelfAvailabilityReportTable,
		apiHook: useLazyGetShelfAvailabilityReportQuery,
		widgetsComponent: InventoryReportWidgets,
		getSummary: (data) => data,
	},
	productExpiration: {
		component: ProductExpirationReportTable,
		apiHook: useLazyGetProductExpirationReportQuery,
		widgetsComponent: ProductExpirationWidgets,
		getSummary: (data) => data,
	},
	shelfMovement: {
		component: ShelfMovementReportTable,
		apiHook: useLazyGetShelfMovementDailySummaryQuery,
		// widgetsComponent: ProductExpirationWidgets,
		getSummary: (data) => data,
	},
};
